import type {ReactElement} from 'react';
import React from 'react';
import type {MediaItemData} from '@Components/simple-media-carousel/simple-media-carousel.types';
import styles from './simple-media-carousel-item.module.scss';

export interface SimpleMediaCarouselItemProps {
  mediaItem: MediaItemData;
  index: number;
  onItemMounted: (el: HTMLVideoElement | HTMLImageElement, index: number) => void;
  onItemLoaded: () => void;
  onIndividualImageLoad?: (externalMediaId: string) => void;
  onIndividualVideoLoad?: (externalMediaId: string) => void;
  onIndividualAssetErrored?: (externalMediaId: string) => void;
  doRetryOnIndividualAssetError?: () => void;
}

export function SimpleMediaCarouselItem({...props}: SimpleMediaCarouselItemProps): ReactElement {
  const media = props.mediaItem;

  if (media.isVideo) {
    return (
      <div className={styles.mediaContainer} key={`carousel-media-item-${props.index}`}>
        <video
          className={styles.media}
          src={media.mediaUrl}
          ref={(el) => {
            if (el) {
              props.onItemMounted(el, props.index);
            }
          }}
          onLoadedMetadata={() => {
            props.onItemLoaded();
            props.onIndividualVideoLoad?.(media.externalMediaId);
          }}
          onError={() => {
            props.onIndividualAssetErrored?.(media.externalMediaId);
            props.doRetryOnIndividualAssetError?.();
          }}
          loop
          autoPlay={props.index === 0}
          muted
        />
      </div>
    );
  }

  return (
    <div className={styles.mediaContainer} key={`carousel-media-item-${props.index}`}>
      <img
        className={styles.media}
        src={media.mediaUrl}
        ref={(el) => {
          if (el) {
            props.onItemMounted(el, props.index);
          }
        }}
        alt="media item"
        onLoad={() => {
          props.onItemLoaded();
          props.onIndividualImageLoad?.(media.externalMediaId);
        }}
        onError={() => {
          props.onIndividualAssetErrored?.(media.externalMediaId);
          props.doRetryOnIndividualAssetError?.();
        }}
      />
    </div>
  );
}
